import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de clientes
 * Maneja todas las operaciones CRUD relacionadas con clientes
 * Migrado a Python FastAPI - Usa pythonApiClient
 */
export const clienteApi = {
  /**
   * Obtiene clientes con filtros
   * @param {number|null} idUser - ID del usuario (opcional - no usado en Python, se filtra por proyecto)
   * @param {number|null} idCliente - ID del cliente específico (opcional)
   * @param {number} page - Página actual (no usado en Python, retorna todos)
   * @param {number} perPage - Elementos por página (no usado en Python)
   * @returns {Promise} - Respuesta de la API
   */
  getAll: (idUser = null, idCliente = null, page = 1, perPage = 10) => {
    if (idCliente) {
      return pythonApiClient.get(`/mantenimientos/clientes/${idCliente}`);
    }
    
    // Python no tiene filtro por usuario, retornar todos los clientes
    return pythonApiClient.get('/mantenimientos/clientes/all');
  },

  /**
   * Obtiene un cliente por ID
   * @param {number} id - ID del cliente
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    return pythonApiClient.get(`/mantenimientos/clientes/${id}`);
  },

  /**
   * Crea un nuevo cliente
   * @param {Object} data - Datos del cliente
   * @param {string} data.nombre - Nombre del cliente
   * @param {string} data.email - Email del cliente
   * @param {string} data.telefono - Teléfono del cliente
   * @param {string} data.direccion - Dirección del cliente
   * @param {number} data.estado - Estado del cliente (1=activo, 0=inactivo)
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    return pythonApiClient.post('/mantenimientos/clientes/', data);
  },

  /**
   * Actualiza un cliente existente
   * @param {number} id - ID del cliente
   * @param {Object} data - Datos actualizados del cliente
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    return pythonApiClient.put(`/mantenimientos/clientes/${id}`, data);
  },

  /**
   * Elimina un cliente
   * @param {number} id - ID del cliente
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    return pythonApiClient.delete(`/mantenimientos/clientes/${id}`);
  },

  /**
   * Obtiene clientes por usuario
   * Nota: Python no tiene filtro directo por usuario, retorna todos los clientes
   * @param {number} userId - ID del usuario
   * @param {number} page - Página actual (no usado)
   * @param {number} perPage - Elementos por página (no usado)
   * @returns {Promise} - Respuesta de la API
   */
  getByUser: (userId, page = 1, perPage = 10) => {
    // Python no tiene filtro por usuario, retornar todos los clientes
    return pythonApiClient.get('/mantenimientos/clientes/all');
  },

  /**
   * Obtiene TODOS los clientes por usuario sin paginación (para comboboxes)
   * Nota: Python no tiene filtro directo por usuario, retorna todos los clientes
   * @param {number} userId - ID del usuario
   * @returns {Promise} - Respuesta de la API
   */
  getAllByUser: (userId) => {
    // Python no tiene filtro por usuario, retornar todos los clientes
    return pythonApiClient.get('/mantenimientos/clientes/all');
  },

  /**
   * Obtiene TODOS los clientes sin filtros ni paginación (para comboboxes)
   * @returns {Promise} - Respuesta de la API
   */
  getAllClientes: () => {
    return pythonApiClient.get('/mantenimientos/clientes/all');
  },

  /**
   * Obtiene clientes asociados a un proyecto específico (query parameter - para compatibilidad)
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getByProyecto: (proyectoId) => {
    return pythonApiClient.get(`/mantenimientos/clientes/?proyecto_id=${proyectoId}`);
  },

  /**
   * Obtiene clientes asociados a un proyecto específico usando resource nesting (para carga masiva)
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getByProyectoRest: (proyectoId) => {
    // Usar el endpoint con query parameter que filtra por proyecto_id
    // Este endpoint usa EXISTS con proyectos_clientes, que es más robusto
    return pythonApiClient.get(`/mantenimientos/clientes?proyecto_id=${proyectoId}`);
  },

  /**
   * Obtiene empresas colaboradoras de un cliente
   * @param {number} clienteId - ID del cliente
   * @returns {Promise} - Respuesta de la API
   */
  getEmpresasColaboradoras: (clienteId) => {
    return pythonApiClient.get(`/mantenimientos/clientes/${clienteId}/empresas-colaboradoras`);
  }
};

export default clienteApi;
